import { apiClient } from './client';

export interface AdminUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  phone?: string;
  level?: string;
  role: 'player' | 'admin';
  is_active: boolean;
  email_verified: boolean;
  created_at: string;
}

export interface AuditLogEntry {
  id: number;
  action: string;
  entity_type: string;
  entity_id?: string;
  entity_name?: string;
  performed_by?: string;
  performed_by_name?: string;
  old_value?: unknown;
  new_value?: unknown;
  ip_address?: string;
  created_at: string;
}

export interface Notification {
  id: number;
  user_id: string;
  type: string;
  title: string;
  body?: string;
  entity_type?: string;
  entity_id?: string;
  is_read: boolean;
  created_at: string;
}

export const adminApi = {
  getUsers: (search?: string) =>
    apiClient.get<AdminUser[]>('/api/admin/users', { params: search ? { search } : {} }),

  updateUser: (id: string, data: Partial<Pick<AdminUser, 'role' | 'is_active' | 'first_name' | 'last_name' | 'email' | 'level'>>) =>
    apiClient.put<AdminUser>(`/api/admin/users/${id}`, data),

  deleteUser: (id: string) =>
    apiClient.delete(`/api/admin/users/${id}`),

  getAuditLog: (limit = 100, offset = 0) =>
    apiClient.get<AuditLogEntry[]>('/api/admin/audit-log', { params: { limit, offset } }),
};

export const notificationsApi = {
  list: () => apiClient.get<Notification[]>('/api/notifications'),
  markRead: (id: number) => apiClient.put(`/api/notifications/${id}/read`),
  markAllRead: () => apiClient.put('/api/notifications/read-all'),
};
